import { render, staticRenderFns } from "./MSuratEdaran.vue?vue&type=template&id=d42d67f2&"
import script from "./MSuratEdaran.vue?vue&type=script&lang=js&"
export * from "./MSuratEdaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports